@let parametersetValue = parameterset();
@let dashboardViewValue = dashboardView();
<!-- Sticky Header/Spalten ergeben im Druck keinen Sinn (kein scrollender
     Kontext mehr) und die nachträgliche CSS-Deaktivierung von außen verliert
     den Wettlauf gegen Angular CDKs eigene Sticky-Neuberechnung (siehe
     isPrinting() in epp-table.component.ts) – deshalb hier direkt einrechnen. -->
@let stickyHeaderValue = stickyHeader() && !isPrinting();
@let greenTableDesignValue = eppService.greenTableDesign();
@let colorMappingPerParametersetValue =
  eppService.colorMappingPerParameterset();
@let colorMappingsValue = eppService.colorMappings();
@let langSignalValue = languageService.langSignal();

<div
  [ngClass]="
    dashboardViewValue
      ? 'dashboard-table-container'
      : stickyHeaderValue
        ? auth.isAppWebView()
          ? 'table-inapp'
          : 'table-container'
        : ''
  ">
  @let tableDataValue = tableData();
  @let parametersValue = parameters();
  @if (tableDataValue && parametersValue) {
    @let resolutionValue = resolution();
    @let userParametersValue = userParameters();
    @let parameterDefinitionsValue = parameterDefinitions();
    @let highlightedHourValue = highlightedHour();
    <table
      mat-table
      [dataSource]="tableDataValue"
      class="table"
      cdkDropList
      cdkDropListOrientation="horizontal"
      [cdkDropListData]="parametersValue"
      (cdkDropListDropped)="onHeaderDrop($event)"
      [ngStyle]="{
        minWidth: 30 + parametersValue.length * 30 + 'px',
        width: '100%',
      }">
      <!-- DTG -->
      <ng-container matColumnDef="dtg" [sticky]="!isPrinting()">
        <th mat-header-cell *matHeaderCellDef class="table__title">
          {{ 'DATETIME.TIME' | translate }}
        </th>
        <ng-container *matCellDef="let element">
          <td
            mat-cell
            class="table__content"
            [class.epp-table-row-highligth]="
              (highlightedHourValue | isNil: false) &&
              (element.valid_at | datex: 'HH') === (highlightedHourValue | hour)
            "
            [attr.rowspan]="resolutionValue.hourly === 12 ? 2 : 1"
            [attr.width]="dashboardViewValue ? 20 : 65"
            [hidden]="
              resolutionValue.hourly === 12 && !(element.valid_at | isNight)
            ">
            @if (resolutionValue.hourly === 12) {
              <strong
                >{{
                  element.valid_at | datex: 'dd' : undefined : langSignalValue
                }}<br />{{
                  element.valid_at
                    | datex: 'DD.MM.' : undefined : langSignalValue
                }}</strong
              >
            } @else if (resolutionValue.hourly < 12) {
              <strong>{{
                element.valid_at | datex: 'HH:mm' : undefined : langSignalValue
              }}</strong>
            }
          </td>
        </ng-container>
      </ng-container>

      <!-- Day/Night -->
      <ng-container matColumnDef="dayNight" [sticky]="!isPrinting()">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="table__title"
          [hidden]="resolutionValue.hourly < 12"></th>
        <td mat-cell *matCellDef="let element" class="table__content">
          <fa-icon [icon]="['far', element['dayNight']]"></fa-icon>
        </td>
      </ng-container>

      <!-- Parameter -->
      @for (parameter of parametersValue; track parameter) {
        <ng-container [matColumnDef]="parameter">
          <th
            mat-header-cell
            *matHeaderCellDef
            cdkDrag
            [cdkDragDisabled]="dashboardViewValue"
            class="table__title"
            [hidden]="
              parameter
                | isHiddenParameter
                  : userParametersValue
                  : resolutionValue
                  : parameterDefinitionsValue
            "
            [ngClass]="parameter | parameterColor"
            [tp]="paramLegend"
            [tpData]="parameter"
            variation="popper"
            trigger="mouseenter"
            tpPlacement="auto"
            [tpMaxWidth]="isMobilePlatform() ? 350 : 'auto'"
            [tpIsLazy]="true"
            (contextmenu)="onHeaderContextMenu($event, parameter)">
            <span
              cdkDragHandle
              style="cursor: grab"
              class="parameter-header-icon">
              <ng-container
                appWmIcon
                [inputParameter]="parameter"></ng-container>
            </span>
          </th>

          <!-- Data per parameter -->
          @switch (parameter) {
            <!-- dd -->
            @case (
              parameter === 'dd' ||
              parameter === 'dd_hub' ||
              parameter === 'dd_950' ||
              parameter === 'dd_120'
                ? parameter
                : ''
            ) {
              <td
                mat-cell
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content"
                [matTooltip]="
                  ('WINDROSE_LONG.FROM' | translate) +
                  ' ' +
                  (element[parameter] | windrose: 8 : true | translate)
                ">
                {{ element[parameter] | windrose | translate }}
                <!-- @if(element[parameter]) {
                             <div [ngStyle]="{transform: 'rotate(' + element[parameter] + 'deg)'}">
                              <fa-icon [icon]="['far', 'long-arrow-down']"></fa-icon>
                            </div>
                            }
                            -->
              </td>
            }
            @case ('symbol') {
              <!-- symbol -->
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content">
                @if (!!element[parameter]) {
                  <img
                    height="26"
                    style="vertical-align: middle"
                    [src]="
                      './assets/symbols/wm/1.0x/' + element['symbol'] + '.png'
                    "
                    [tp]="bigSymbol"
                    [tpIsLazy]="true"
                    variation="popper"
                    class="weather-symbol-small"
                    trigger="mouseenter" />
                  <ng-template #bigSymbol>
                    <img
                      class="weather-symbol-big"
                      [src]="
                        './assets/symbols/wm/3.0x/' + element['symbol'] + '.png'
                      "
                      height="150" />
                    <p align="center">
                      {{
                        'MAPPING.WW.' +
                          ((element['ww'] | isNil: false)
                            ? element['ww']
                            : element['ww1']) | translate
                      }}
                    </p>
                  </ng-template>
                } @else {
                  --
                }
              </td>
            }

            <!-- ne -->
            @case (
              parameter === 'nm' ||
              parameter === 'ne' ||
              parameter === 'nl' ||
              parameter === 'nh'
                ? parameter
                : ''
            ) {
              <td
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content"
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                [ngClass]="'ne-color-' + (element[parameter] | round)">
                {{ element[parameter] | round }}/8
              </td>
            }
            @case (
              parameter === 'ne_symbol' ||
              parameter === 'nl_symbol' ||
              parameter === 'nm_symbol' ||
              parameter === 'nh_symbol'
                ? parameter
                : ''
            ) {
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content">
                @if (element[parameter] | isNil: false) {
                  <div class="table__svgWrapper special">
                    <mat-icon
                      [svgIcon]="'ne_' + (element[parameter] | round)"
                      class="ne-icon"
                      [matTooltip]="
                        (element[parameter] | round) +
                        '/8 ' +
                        ('MAPPING.NE.' + (element[parameter] | round)
                          | translate)
                      ">
                    </mat-icon>
                  </div>
                } @else {
                  --
                }
              </td>
            }
            @case (
              parameter === 'ff' ||
              parameter === 'ff_hub' ||
              parameter === 'ffx_hub' ||
              parameter === 'ff_ms' ||
              parameter === 'ff_kn' ||
              parameter === 'ff_120' ||
              parameter === 'ff_950' ||
              parameter === 'ffx' ||
              parameter === 'ffx_ms' ||
              parameter === 'ffx_kn' ||
              parameter === 'ff_mph' ||
              parameter === 'ff_950_mph' ||
              parameter === 'ff50_ms' ||
              parameter === 'ff100_ms' ||
              parameter === 'ffx50_ms' ||
              parameter === 'ffx100_ms' ||
              parameter === 'ff50_kn' ||
              parameter === 'ff100_kn' ||
              parameter === 'ffx50_kn' ||
              parameter === 'ffx100_kn' ||
              parameter === 'ffx_mph' ||
              parameter === 'rh'
                ? parameter
                : ''
            ) {
              <!-- values to round -->

              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content"
                [ngStyle]="
                  parametersetValue
                    | colorMapping
                      : parameter
                      : element[parameter]
                      : greenTableDesignValue
                      : colorMappingPerParametersetValue
                      : colorMappingsValue
                ">
                {{ element[parameter] | round }}
              </td>
            }
            @case (
              parameter === 'sunrise' || parameter === 'sunset' ? parameter : ''
            ) {
              <!-- sunrise + sunset -->
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content">
                {{ element[parameter] | sunrise: element['dtg'] }}
              </td>
            }

            <!-- possibilities: round: 5 -->
            @case (
              (parameter | parameterClass) === 'possibility' ? parameter : ''
            ) {
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content">
                {{ element[parameter] | round }}
              </td>
            }

            @case ((parameter | parameterClass) === 'tt' ? parameter : '') {
              <!-- temperatures without colors background: format %0.1f -->

              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content">
                {{ element[parameter] | number: '1.1-1' }}
              </td>
            }

            @case (
              parameter === 'windpower' ||
              parameter === 'windpower_bil' ||
              parameter === 'windpower_bic' ||
              parameter === 'solarpower' ||
              parameter === 'solarpower_snl' ||
              parameter === 'solarpower_snc'
                ? parameter
                : ''
            ) {
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content">
                {{ element[parameter] | round }}
              </td>
            }

            @case (
              (parameter | parameterClass) === 'tt_color' ? parameter : ''
            ) {
              <!-- temperatures with colors background: format %0.1f -->
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content"
                [ngStyle]="
                  parametersetValue
                    | colorMapping
                      : parameter
                      : element[parameter]
                      : greenTableDesignValue
                      : colorMappingPerParametersetValue
                      : colorMappingsValue
                ">
                {{
                  element.hasOwnProperty(parameter)
                    ? (element[parameter] | number: '1.1-1')
                    : '--'
                }}
              </td>
            }

            @case ('vis') {
              <!-- visibility in km/h -->
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content">
                {{
                  element.hasOwnProperty(parameter)
                    ? (element[parameter] | vis)
                    : '--'
                }}
              </td>
            }

            @case ((parameter | parameterClass) === 'index' ? parameter : '') {
              <!-- indices -->
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content"
                [ngStyle]="
                  parametersetValue
                    | colorMapping
                      : parameter
                      : element[parameter]
                      : greenTableDesignValue
                      : colorMappingPerParametersetValue
                      : colorMappingsValue
                "
                [matTooltip]="
                  'MAPPING.INDEX.' + parameter + '.' + element[parameter]
                    | translate
                ">
                {{ element[parameter] }}
              </td>
            }

            @case (
              (parameter | parameterClass) === 'condition' ? parameter : ''
            ) {
              <!-- conditions -->
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content"
                [ngStyle]="
                  parametersetValue
                    | colorMapping
                      : parameter
                      : element[parameter]
                      : greenTableDesignValue
                      : colorMappingPerParametersetValue
                      : colorMappingsValue
                "
                [matTooltip]="
                  parametersetValue.indexOf('power') > 0
                    ? ('MAPPING.POWER_CONDITION.' + element[parameter]
                      | translate)
                    : ('MAPPING.CONDITION.' + element[parameter] | translate)
                ">
                {{
                  element.hasOwnProperty(parameter)
                    ? parametersetValue.indexOf('power') > 0
                      ? ('MAPPING.POWER_CONDITION_SHORT.' + element[parameter]
                        | translate)
                      : ('MAPPING.CONDITION_SHORT.' + element[parameter]
                        | translate)
                    : '--'
                }}
              </td>
            }

            @case (
              parameter === 'sn' ||
              parameter === 'sn_fresh' ||
              parameter === 'sn_panel'
                ? parameter
                : ''
            ) {
              <!-- snow -->
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content"
                [ngClass]="
                  element[parameter] | colorMappingSnow: greenTableDesignValue
                ">
                {{
                  element.hasOwnProperty(parameter)
                    ? (element[parameter] | rr: element['ww'])
                    : '--'
                }}
              </td>
            }

            @case ('sn_in') {
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content"
                [ngClass]="
                  element[parameter] | colorMappingSnow: greenTableDesignValue
                ">
                {{
                  element.hasOwnProperty(parameter)
                    ? (element[parameter] | rr: element['ww'])
                    : '--'
                }}
              </td>
            }

            @case ('rr') {
              <!-- precipitaion -->
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content">
                {{
                  element.hasOwnProperty(parameter)
                    ? (element[parameter] | rr: element['ww'])
                    : '--'
                }}
              </td>
            }

            @case ('rr_in') {
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content">
                {{
                  element.hasOwnProperty(parameter)
                    ? (element[parameter] | rr: element['ww'] : 'in')
                    : '--'
                }}
              </td>
            }

            @case ('ww') {
              <!-- precipitation type -->
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content"
                [attr.width]="dashboardViewValue ? 50 : 70">
                <div class="table__svgWrapper">
                  @if (element[parameter] > 39) {
                    <img
                      height="16"
                      matTooltip="{{
                        'MAPPING.NSL_ART.' + element[parameter] | translate
                      }}"
                      src="/assets/symbols/wm/ww/{{
                        element[parameter]
                      }}.svg" />
                  } @else {
                    <span style="color: lightgrey">--</span>
                  }
                </div>
              </td>
            }

            @default {
              <!-- all others -->
              <td
                [class.epp-table-row-highligth]="
                  (highlightedHourValue | isNil: false) &&
                  (element.valid_at | datex: 'HH') ===
                    (highlightedHourValue | hour)
                "
                mat-cell
                *matCellDef="let element"
                [hidden]="
                  parameter
                    | isHiddenParameter
                      : userParametersValue
                      : resolutionValue
                      : parameterDefinitionsValue
                "
                class="table__content">
                {{
                  element.hasOwnProperty(parameter) ? element[parameter] : '--'
                }}
              </td>
            }
          }
        </ng-container>
      }

      <!-- 1-2 Header rows -->
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: stickyHeaderValue"></tr>

      @if (!dashboardViewValue) {
        @for (unit of units(); track $index) {
          <ng-container [matColumnDef]="'UNITS.' + unit">
            <th
              mat-header-cell
              *matHeaderCellDef
              [hidden]="
                unit
                  | isHiddenParameter
                    : userParametersValue
                    : resolutionValue
                    : parameterDefinitionsValue
              "
              class="table__units">
              {{ 'UNITS.' + unit | translate }}
            </th>
          </ng-container>
        }
        <tr
          mat-header-row
          *matHeaderRowDef="displayedUnits; sticky: !isPrinting()"></tr>
      }

      @if (resolutionValue.hourly < 12) {
        <ng-container matColumnDef="groupHeader">
          <td
            colspan="999"
            mat-cell
            *matCellDef="let groupBy"
            class="table__date-row">
            <strong>{{
              groupBy.date
                | datex: 'dddd DD.MM.YYYY' : undefined : langSignalValue
            }}</strong>
          </td>
        </ng-container>
        <tr
          mat-row
          *matRowDef="let row; columns: ['groupHeader']; when: isGroup"></tr>
      }

      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</div>

<ng-template #paramLegend let-hide let-parameter="data">
  <p>
    <strong>{{ 'METPARA_EPP.' + parameter | translate }}</strong>
  </p>
  @if (parameter | hasLegend) {
    <table class="legend-table">
      @for (
        row of parameter
          | getLegend
            : parametersetValue
            : greenTableDesignValue
            : colorMappingPerParametersetValue
            : colorMappingsValue;
        track $index
      ) {
        <tr>
          <!--
          <td align="center" [ngClass]="(parameter | parameterClass) === 'index' ? '' : row['class']" width="40">
             @if((parameter | parameterClass) === 'index') {
              <div class="legend-index" [ngClass]="row['class']"></div>
             }
          </td>
          -->
          <td align="center" [ngStyle]="row['style']" width="40"></td>
          @if (row.hasOwnProperty('value')) {
            <td class="legend-value">
              <span>{{ row['value'] }}</span>
            </td>
          }
          @if (row.hasOwnProperty('text')) {
            <td>
              <span>{{ 'MAPPING.' + row['text'] | translate }}</span>
            </td>
          }
          @if (row.hasOwnProperty('text2')) {
            <td>
              <span>{{ 'MAPPING.' + row['text2'] | translate }}</span>
            </td>
          }
        </tr>
      }
    </table>
  }
</ng-template>
